var $grid = null;

var GLightboxGalllery = null;

$(document).ready(function () {
    function isVisible(element) {
        var winTop = $(window).scrollTop();
        var winBottom = winTop + $(window).height();
        var elTop = $(element).offset().top;
        var elBottom = elTop + $(element).height();

        return elBottom >= winTop && elTop <= winBottom;
    }

    function checkVisibility() {
        $(".animate__animated").each(function () {
            if (isVisible(this) && !$(this).hasClass("visible")) {
                $(this).addClass("visible " + $(this).data("animate"));
            }
        });
    }

    $(window).scroll(function (event) {
        var scroll = $(window).scrollTop();

        if (scroll > 100) {
            $(".navbar-primary").addClass("navbar-primary-hidden");
        } else {
            $(".navbar-primary").removeClass("navbar-primary-hidden");
        }

        checkVisibility();
    });

    switchPortfolio('portraits');

    initPortfolioMasonry();

    $("body").on("click", ".portfolio-grid-item", function () {
        var type = $(this).data("type");

        if (type == "video") {
            var videoUrl = $(this).data("video-url");
            window.open(videoUrl, '_blank');
            return false;
        }

        var index = $(this).data("index");

        GLightboxGalllery.openAt(index - 1);
    });

    $(".btn-portfolio-switcher").on("click", function () {
        $('.btn-portfolio-switcher.btn-orange').addClass('btn-outline-secondary').removeClass('btn-orange')
        $(this).addClass('btn-orange').removeClass('btn-outline-secondary')

        $grid.masonry('destroy')
        switchPortfolio($(this).data('type'));
    });
});

function initPortfolioMasonry() {
    // init Masonry
    $grid = $(".portfolio-grid").masonry({
        itemSelector: ".portfolio-grid-item",
        columnWidth: ".portfolio-grid-sizer",
        gutter: ".portfolio-gutter-sizer",
        percentPosition: true,
        horizontalOrder: true
    });

    // layout Masonry after each image loads
    $grid.imagesLoaded().progress(function () {
        $grid.masonry();
    });
}

function clearPortfolio() {
    $('.portfolio-grid .portfolio-grid-item').remove();
}

function initGLightboxGalllery(portfolio) {
    var portfolioElements = [];

    portfolioList[portfolio].forEach((element, index) => {
        portfolioElements.push ({
            'href': element.type == 'image' ? element.url : element.video_url,
            'type': element.type,
        })
    });

    if (GLightboxGalllery != null) {
        GLightboxGalllery.destroy();
    }

    GLightboxGalllery = GLightbox({
        elements: portfolioElements,
        autoplayVideos: true,
    });
}

function switchPortfolio(portfolio) {
    clearPortfolio();

    portfolioList[portfolio].forEach((element, index) => {
        $(".portfolio-grid").append(`
            <div class="portfolio-grid-item ${
                (element.width == "2x") ? "portfolio-grid-item--width2" : ""
            }" data-index="${index + 1}" data-type="${element.type}" data-video-url="${element.video_url}">
                <img src="${
                    element.url
                }" width="100%" />
                <div class="py-2 px-2 d-none" style="background-color: #252525;">
                    ${element.caption}
                </div>
            </div>
        `);
    });

    initPortfolioMasonry()
    initGLightboxGalllery(portfolio)
}